import React from "react";

import { Button, HStack } from "components";

const NavToggle = ({ buttons }) => {
  if (buttons) {
    return (
      <HStack space="spacing.2">
        {buttons.map(({ appearance, disabled, label, onClick }, index) => (
          <Button
            children={label}
            intent="primary"
            appearance={appearance}
            onClick={onClick}
            disabled={disabled}
            key={"navToggle" + index}
          />
        ))}
      </HStack>
    );
  } else {
    return null;
  }
};

export default NavToggle;
